export const PriceUpdateTypes = {
  SET_VALUE: 'SET_VALUE',
  SET_ACTIVE: 'SET_ACTIVE',
  SET_LINE_DEACTIVE: 'SET_LINE_DEACTIVE',
  DELETE: 'DELETE',
  UNDELETE: 'UNDELETE',
  SET_CC: 'SET_CC',
  SET_LC: 'SET_LC',
};
